// @flow

import  React, { Component } from "react"; 
import { Icon } from "tabler-react";
import defaultStrings from "../../data/LoginPage.strings";
import {Auth} from '../../Auth/Auth';
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NavLink, withRouter } from "react-router-dom";
import "../../Temas/OneLineTheme.css";

class LoginPageNew extends Component {
  constructor(props){
    super(props);
    this.state = {
      banderaPersonalizada:false,
      username: "",
      password: "",
      showmessage: false,
      message: "No message",
      loginMessage: null
    };
  }

  componentWillMount=()=>{
    //alert(window.location);
  }

  changePassword = (event) =>{
    this.setState({password: event.target.value});
  }

  changeUsername = (event) =>{
    this.setState({username: event.target.value});
  }

  getLogin = () =>{
    this.setState({showmessage: false});
    Auth("login", this.state.username, this.state.password).then((res) => {
      if(res.token){
        this.setState({loginMessage: "Cargando perfiles .."});
        Crud_Catalogos("plataformasUsuariosPerfiles/username", "usuarios", "post","", {"username": this.state.username}, "", "currentUser").then((returnVal) => {
          this.setState({loginMessage: "Construyendo menu de opciones ..."});
          sessionStorage.setItem("usuario", JSON.stringify(returnVal[0].usuario));
          sessionStorage.setItem("perfil", JSON.stringify(returnVal[0].perfil));
          sessionStorage.setItem("plataforma", JSON.stringify(returnVal[0].plataforma));
          sessionStorage.setItem("currentUser", JSON.stringify(returnVal));
          
          // Guardar id_transportista si existe
          if (returnVal[0].idTransportista) {
            sessionStorage.setItem("idTransportista", returnVal[0].idTransportista);
          }

          if([1,3].includes(returnVal[0].plataforma.plataformaTipo.id)){
            this.setState({banderaPersonalizada:true});
          }
          
          // Simplified navigation logic
          setTimeout(() => {
            window.location.href = "/monitoreo?mtipo=0";
          }, 1000);
          
        }).catch(err => {
          this.setState({loginMessage: null});
          this.setState({showmessage: true});
          this.setState({message: "Error al cargar perfiles de usuario"});
        });
      }else{
        this.setState({showmessage: true});
        this.setState({message: res.message});
      }
    }).catch(err => {
      this.setState({showmessage: true});
      this.setState({message: "Error de conexión"});
    });
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.getLogin();
    }
  }

  render(){
    const { strings = {} } = this.props;
    
    return (
      <div className="one-login-container">
        <div style={{
          position: 'absolute',
          left: '350px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: 'white'
        }}>
          <div style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '10px' }}>
            Your Number ONE<br/>Shipping Partner
          </div>
          <div style={{ fontSize: '14px' }}>
            Simplify your shipping with us
          </div>
        </div>
        
        <div className="one-login-card">
          
          <h1 className="one-title">Welcome to ONE</h1>
          <p className="one-subtitle">Your Number ONE Shipping Partner</p>
          
          {this.state.showmessage && (
            <div className="one-alert">
              {this.state.message}
            </div>
          )}

          {this.state.loginMessage ? (
            <div className="one-loading">
              <div className="one-loading-text">{this.state.loginMessage}</div>
              <div className="one-spinner"></div>
            </div>
          ) : (
            <form>
              <div className="one-form-group">
                <label className="one-form-label">
                  {defaultStrings.usernameLabel}
                </label>
                <input
                  type="text"
                  className="one-form-input"
                  placeholder={defaultStrings.usernamePlaceholder}
                  value={this.state.username}
                  onChange={this.changeUsername}
                />
              </div>
              
              <div className="one-form-group">
                <label className="one-form-label">
                  {strings.passwordLabel || defaultStrings.passwordLabel}
                </label>
                <input
                  type="password"
                  className="one-form-input"
                  placeholder={strings.passwordPlaceholder || defaultStrings.passwordPlaceholder}
                  value={this.state.password}
                  onChange={this.changePassword}
                  onKeyDown={this._handleKeyDown}
                />
              </div>
              
              <button
                type="button"
                className="one-login-button"
                onClick={this.getLogin}
              >
                <Icon name="user" />
                Login
              </button>
            </form>
          )}
        </div>
        
        <div className="one-footer">
          © 2024 Ocean Network Express. All rights reserved.
        </div>
      </div>
    );
  }
}

export default LoginPageNew;
